'use strict';

var $ = require('jquery');

function init() {
	var selector_gallery = '.gallery';
	var selector_viewer = '.gallery__view';
	var selector_thumbs = '.gallery__thumb';
	var selector_media = '.image';

	var $gallery = $(selector_gallery);
	if ($gallery.length === 0) {
		return;
	}

	$gallery.each(function(index,element) {
		var currentIndex = 0;
		var removeOldMediaTimeoutID = undefined;
		var $elem = $(element);
		var $galleryView = $elem.find(selector_viewer);
		var $galleryThumbs = $elem.find(selector_thumbs);

		function removeOldMedia() {
			// Remove all but first one
			var $mediaElements = $galleryView.find(selector_media);
			for (var i = 1; i < $mediaElements.length; ++i) {
				$($mediaElements[i]).remove();
			}
			$galleryView.attr('status', '');

			removeOldMediaTimeoutID = undefined;
		}

		function activateByIndex(newIndex) {
			currentIndex = newIndex;

			var $thumb = $($galleryThumbs[newIndex]);
			var $this = $thumb.find('a');
			var href = $this.attr('href');
			var $galleryMedia = $galleryView.find(selector_media);

			if ($galleryMedia.attr('src') !== href) {
				if (removeOldMediaTimeoutID !== undefined) {
					clearTimeout(removeOldMediaTimeoutID);
				}

				// Remove 'active' class from all thumbnails and then add to current
				$galleryThumbs.attr('status', '');
				$thumb.attr('status', 'active');

				// Load the new media
				$galleryView.attr('status', 'loading');
				var alt = $this.find('img').attr('alt') || ' ';
				var title = $this.find('img').attr('title') || ' ';

				var newImage = [
					'<div class="' + $this.attr('class') + '" style="background-image: url(' + href + ');" imageStyle="' + ($this.attr('imageStyle') || '') + '" title="' + title + '">',
					'<img src="' + href + '" alt="' + alt + '" title="' + title + '"  />',
					'</div>'
				].join();
				$galleryView.prepend($(newImage));

				// Have media removing removed once done
				removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 1000);
			}
		}

		// Set up thumbnail clicks
		function thumbClickHandler(event) {
			event.preventDefault();

			var newIndex = $(this).parent('.gallery__thumb').index();
			activateByIndex(newIndex);

			// trackControlEvent('Thumbnail');
		}
		$galleryThumbs.on('click', 'a', thumbClickHandler);


		function createControls() {
			/* TODO: make the dynamic */
		}

		function createControlsEventHandlers() {
			// Set up "previous" button click
			var $prevEl = $elem.find('button[class*="--prev"]');
			var prevClickHandler = function(event) {
				var newIndex = currentIndex ?
					currentIndex - 1 :
					$galleryThumbs.length - 1;

				activateByIndex(newIndex);
				// trackControlEvent('Previous');
			};
			$prevEl.on('click', prevClickHandler);

			// Set up "next" button click
			var $nextEl = $elem.find('button[class*="--next"]');
			var nextClickHandler = function(event) {
				var newIndex = currentIndex < $galleryThumbs.length - 1 ?
					currentIndex + 1 :
					0;

				activateByIndex(newIndex);
				// trackControlEvent('Next');
			};
			$nextEl.on('click', nextClickHandler);
		}
		createControlsEventHandlers();
	});
}
module.exports = {
	init: init
};